import { isDefined } from '@sgme/fp';
import { type Type, type } from 'arktype';

import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';

export function validateArrayWith<T, X>(validator: Type<T, X>): Type<T[], X> {
  // @ts-expect-error Arktype pipe typing issue
  return arkScope
    .type('Array')
    .pipe((array) => {
      return array
        .map((el) => {
          const res = validator(el);
          return res instanceof type.errors ? undefined : res;
        })
        .filter(isDefined);
    })
    .default(() => []);
}
